// Translate My Store selector: switch language as soon as one is picked, instead of picking
// then pressing "Change" (that button is hidden in footer.css). The app renders the selector a
// while after load and rebuilds the list on every pick, so listen once on the document. Capture
// phase, because the app's own handler may detach the clicked item before the event bubbles up.
document.addEventListener(
  'click',
  (event) => {
    const item = event.target.closest(
      '.ht-tms__duo-selector__dropdown-wrapper .ht-tms-single-dropdown__container--language .ht-tms-option__item'
    );
    const submit = item?.closest('.ht-tms__duo-selector')?.querySelector('.ht-tms__duo-selector__button');
    if (!submit) return;

    // Let the app record the picked language first, then submit it like "Change" does.
    setTimeout(() => submit.click());
  },
  true
);
